import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { IonSelect, IonSelectOption, SelectCustomEvent } from '@ionic/angular/standalone';

import { SvgIconService } from '../../../services/svg-icon/svg-icon.service';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

export type OptionsType = {
    label: string;
    value: string | number;
};

@Component({
    selector: 'lib-select',
    standalone: true,
    imports: [CommonModule, IonSelect, IonSelectOption, InputWrapperComponent, ReactiveFormsModule],
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit {
    /* eslint-disable */
    @Input() label: string = '';
    @Input() placeholder?: string = '';

    @Input() form: FormGroup = new FormGroup({
        input: new FormControl()
    });
    @Input() controlName: string | null = 'input';

    @Input() options?: OptionsType[] = [];

    @Input() value?: any;
    @Input() required: boolean = false;
    @Input() submitAttempt: boolean = false;
    @Input() selected: boolean = false;

    @Input() longContent: boolean = false;
    @Input() multiple: boolean = false;
    @Input() ionItemWrap: boolean = true;
    @Input() addBottomMargin: boolean = true;
    @Input() enableOptionsMaxHeight: boolean = false;

    @Input() interface: 'action-sheet' | 'alert' | 'popover' | 'modal' = 'popover';
    @Input() interfaceOptions: { [key: string]: string | number | null | undefined } = {};

    @Input() errorText: string | undefined;
    @Input() helperText: string | undefined;

    @Output() selectChange = new EventEmitter();

    formInput: AbstractControl | null = null;
    toggleIcon: string | null = '';

    constructor(private svgIconService: SvgIconService) {
        this.toggleIcon =
            svgIconService.sharedComponentsIconAssetPath + svgIconService.getIconFileNameFromObject('chevron-down');
    }

    ngOnInit() {
        if (this.controlName) {
            this.formInput = this.form?.controls[this.controlName];
        }

        if (this.value) {
            this.formInput?.patchValue(this.value);
        }

        this.interfaceOptions = {
            ...this.interfaceOptions,
            cssClass: `select-${this.interface} ${this.longContent === true ? 'select-long-content' : ''} ${
                this.enableOptionsMaxHeight === true ? 'select-options-max-height' : ''
            }`,
            header: this.label
        };
    }

    onSelectChange(event: SelectCustomEvent) {
        this.errorText = '';
        this.selectChange.emit(event.detail.value);
    }
}
